import { linkifyText } from '@easyhelp/shared';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

/**
 * Testo semplice di una voce del thread (DEC-008): a capo conservati, gli URL `http(s)` resi
 * cliccabili in una nuova scheda, senza `opener` né `referrer`. Nessun HTML del testo viene
 * interpretato: React fa l'escape di ogni pezzo e altri schemi (`javascript:`) restano testo.
 */
export function ThreadText({ text }: { text: string }) {
  return (
    <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
      {linkifyText(text).map((part, index) =>
        part.type === 'link' ? (
          <Link key={index} href={part.url} target="_blank" rel="noopener noreferrer">
            {part.url}
          </Link>
        ) : (
          part.value
        )
      )}
    </Typography>
  );
}
